import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useApolloClient } from '@ts-gql/apollo';

// I think this is overselecting. The search client in the vue app was called from everywhere
// whereas this one is only built for autocompletes
// it MIGHT power the select-menus for the filter bars one day though
const SEARCH_CLIENTS_AUTOCOMPLETE = gql`
  query SearchClientsAutocomplete(
    $searchTerm: String!
    $includeNonClients: Boolean!
    $take: Float!
  ) {
    searchClients(
      searchTerm: $searchTerm
      includeNonClients: $includeNonClients
      take: $take
    ) {
      cloudId
      name
      endDateUtc
      isDeleted
    }
  }
` as import('../../__generated__/ts-gql/SearchClientsAutocomplete').type;

export type SearchClientsAutocompleteVariables = OperationVariables<
  typeof SEARCH_CLIENTS_AUTOCOMPLETE
>;

export type SearchClientsAutocompleteResult = OperationData<
  typeof SEARCH_CLIENTS_AUTOCOMPLETE
>;

export const useDebtorAutoComplete = () => {
  const client = useApolloClient();

  // This is the easy to call function we can await that we need to return
  // for this usage, we have to have a promise we can await. We can't do renderloop and useeffect and usememo etc
  // we absolutely need something we can await, lightly transform the results for display, and hand back to the autocomplete
  const doSearch = async (variables?: SearchClientsAutocompleteVariables) => {
    if (!variables?.searchTerm) {
      return { data: [] };
    }
    const options = {
      query: SEARCH_CLIENTS_AUTOCOMPLETE,
      variables,
      context: { service: 'clients' },
    };
    const clientsResult =
      await client.query<typeof SEARCH_CLIENTS_AUTOCOMPLETE>(options);

    if (clientsResult.errors) {
      return { error: true };
    }
    if (!clientsResult.data?.searchClients?.length) {
      return { data: [] };
    }

    // actually nothing else to do here, simple search
    return {
      data: clientsResult.data.searchClients,
    };
  };
  return doSearch;
};
